import React from 'react';
import Parallax from 'parallax-js';
import Button from './Button';
import LocaleText from './LocaleText';

class Home extends React.Component {
    componentDidMount() {
        // initiate parallax js
        this.parallaxInstance = new Parallax(this.parallaxScene);

        setTimeout(() => {
            this.parallaxScene.className += ' is-on';
        }, 1000);
    }

    render() {
        const { lang } = this.props.match.params;
        return (
            <div id="home" className="home-page">
                <div className="text-wrapper">
                    <h1>
                        <LocaleText textKey="home.title" />
                    </h1>

                    <p>
                        <LocaleText textKey="home.copy" />
                    </p>

                    <Button
                        className="is-primary is-bigger is-large-on-tablet"
                        to={`/${lang}/pens`}
                    >
                        <LocaleText textKey="home.cta" />
                    </Button>
                </div>
                <div className="pen-images-wrapper">
                    <img
                        src="../img/homepage/white-pen-home.png"
                        className="blur-pen"
                        alt="white pen"
                    />
                    <img
                        src="../img/homepage/silver-pen-home.png"
                        className="silver-pen"
                        alt="silver pen"
                    />
                    <img
                        src="../img/homepage/blue-pen-home.png"
                        className="blue-pen"
                        alt="blue pen"
                    />
                    <img
                        src="../img/homepage/black-pen-home.png"
                        className="black-pen"
                        alt="black pen"
                    />
                    <img
                        src="../img/homepage/white-pen-home.png"
                        className="white-pen"
                        alt="white pen"
                    />
                </div>
                <div
                    className="pen-images-wrapper--desktop"
                    ref={ref => {
                        this.parallaxScene = ref;
                    }}
                >
                    <div data-depth="0.1">
                        <img
                            src="../img/homepage/blue-pen-home.png"
                            className="blue-pen"
                            alt="blue pen"
                        />
                    </div>
                    <div data-depth="0.4">
                        <img
                            src="../img/homepage/black-pen-home.png"
                            className="black-pen"
                            alt="black pen"
                        />
                    </div>
                    <div data-depth="1.4" className="is-bottom">
                        <img
                            src="../img/homepage/white-pen-home.png"
                            className="white-pen"
                            alt="white pen"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;
